module.exports = __webpack_public_path__ + "img/20190717162423778.d2aac0f4.png";